var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.75 12 C 21.75 6.613281 17.386719 2.25 12 2.25 C 6.613281 2.25 2.25 6.613281 2.25 12 C 2.25 17.386719 6.613281 21.75 12 21.75 C 17.386719 21.75 21.75 17.386719 21.75 12 Z M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 7.960938 7.75 C 8.328125 6.703125 9.324219 6 10.433594 6 L 13.167969 6 C 14.804688 6 16.125 7.328125 16.125 8.957031 C 16.125 10.015625 15.558594 10.996094 14.640625 11.527344 L 13.125 12.394531 C 13.117188 13.003906 12.613281 13.5 12 13.5 C 11.375 13.5 10.875 13 10.875 12.375 L 10.875 11.742188 C 10.875 11.339844 11.089844 10.96875 11.441406 10.765625 L 13.519531 9.578125 C 13.738281 9.449219 13.875 9.214844 13.875 8.960938 C 13.875 8.570312 13.554688 8.253906 13.167969 8.253906 L 10.433594 8.253906 C 10.273438 8.253906 10.132812 8.351562 10.082031 8.503906 L 10.0625 8.558594 C 9.859375 9.144531 9.210938 9.449219 8.628906 9.242188 C 8.046875 9.039062 7.738281 8.390625 7.945312 7.808594 L 7.964844 7.753906 Z M 10.5 16.5 C 10.5 15.671875 11.171875 15 12 15 C 12.828125 15 13.5 15.671875 13.5 16.5 C 13.5 17.328125 12.828125 18 12 18 C 11.171875 18 10.5 17.328125 10.5 16.5 Z M 10.5 16.5 ",
    fill: "#212737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circle-question.7d7e293c8292f004b5f2bba0fa782e24.svg";
export { ForwardRef as ReactComponent };